import {
  Alert,
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Typography,
  CircularProgress,
} from '@mui/material';

import React from 'react';
import Webcam from 'react-webcam';

import { ReactComponent as VidoRecordIcon } from '../../../../assets/icons/Record.svg';

import { ReactComponent as VideoStopRecordIcon } from '../../../../assets/icons/StopRecord.svg';
import ProgressTimer from '@atoms/ProgressTimer';
import { useCameraAudioPermission } from '@/hooks/CameraAudioPerimissionHook';
import VideoProgressPlayer from '@atoms/VidePlayer';
import Paths from '@/routes/paths';
import { useNavigate } from 'react-router-dom';
import useCandidate from '@authentication/hooks/useCandidate';
import { Video } from './cv-video.styled';
import DialogContract from '@/modules/DialogContract';
import { MIN_TIME_SEC_RECORD, ONE_SEC } from '@/constant';
import { generateBlobUrl, recordChunkToBlob } from '@/utils';
import DialogHint from '@/modules/HintDialog';
import { useCandidateStore } from '@/store/candidate.store';
import StepLabel from '@/modules/StepLabel';
import { createFolderCandidate, uploadVideStep } from '@services/uploadCvVideo';
import EastIcon from '@mui/icons-material/East';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import useCandidateId from '@/hooks/CandidateIdHook';
const videoConstraints = {
  facingMode: 'user',
};
const audioConstraints = {
  suppressLocalAudioPlayback: true,
  noiseSuppression: true,
  echoCancellation: true,
};

function CvVideoCard() {
  const {
    updateLevel,
    levels,
    setStep,
    decrementStep,
    step,
    updateActiveStatus,
    updatePassedStatus,
    setRecordChunksLevel,
    setVideoDurationTotal,
    deleteVideoById,
  } = useCandidateStore();
  const navigation = useNavigate();

  const { errorPermission, activePermission } = useCameraAudioPermission();
  const { setVideo, recordChunksG, setVideoDuration, videoDuration } =
    useCandidate();
  // const [videoDurationTotal, setVideoDurationTotal] = React.useState<any>([]);
  const [isAcceptedContract, setIsAcceptedContract] =
    React.useState<boolean>(false);
  const [sec, setSect] = React.useState(0);
  const [recordChunks, setRecordChunks] = React.useState([]);
  const candidateId = useCandidateId();
  const [loading, setIsloading] = React.useState(false);

  const [isRecording, setIsRecording] = React.useState(false);
  const [playVideo, setPlayVideo] = React.useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = React.useState(true);
  const [playedSeconds, setPlayedSeconds] = React.useState(0);
  const [openDialogContract, setOpenDialogContract] = React.useState(true);
  const [disableButtonRecord, setDisableButtonRecord] = React.useState(true);
  const [isShowHintDialaog, setIsShowHint] = React.useState(false);
  const mediaRecorderRef = React.useRef<any>(null);
  const webcamRef = React.useRef<Webcam>(null);
  const videoRef = React.useRef<any>(null);
  const [errorMessage, setErrorMessage] = React.useState('');

  const [maxTimeRecord, setMaxTimeSecRecord] = React.useState<any>(
    levels.filter((level) => level.isActive)[0].timeRecord,
  );
  const currentLevel = levels.filter((level) => level.isActive)[0];

  React.useEffect(() => {
    const max: any = levels.filter((level) => level.isActive)[0].timeRecord;
    setMaxTimeSecRecord(max);
  }, [step, setStep, updateActiveStatus, updatePassedStatus]);

  const allsteps = levels.map((level) => `${level.id}.${level.label}`);

  React.useEffect(() => {
    const Timer = setInterval(() => {
      if (sec < maxTimeRecord && isRecording) {
        setSect(sec + 1);
        setVideoDuration(sec + 1);
      }
    }, ONE_SEC);

    return () => {
      clearInterval(Timer);
    };
  }, [sec, isRecording]);

  React.useEffect(() => {
    const blobUrl = generateBlobUrl(recordChunks);
    setVideo(blobUrl);
    updateLevel(currentLevel.id, blobUrl);

    return () => {
      URL.revokeObjectURL(blobUrl);
    };
  }, [recordChunks, recordChunksG]);

  const handleCloseDialogContract = () => {
    setOpenDialogContract(false);
    setIsShowHint(false);
  };

  const handleDataAvailable = React.useCallback(
    ({ data }: any) => {
      if (data.size > 0) {
        setRecordChunks((prev: any) => prev.concat(data));

        setRecordChunksLevel(currentLevel.id, recordChunks);
      }
    },
    [recordChunks, currentLevel.id],
  );

  const handleVideoClick = () => {
    setIsVideoPlaying((prevState) => !prevState);
  };

  React.useEffect(() => {
    const handleCreateFolder = async () => {
      if (candidateId) {
        await createFolderCandidate(candidateId);
      }
    };
    handleCreateFolder();
  }, [candidateId]);

  const handleStartRecordVideo = () => {
    try {
      setIsRecording(true);

      navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      const myStream = webcamRef.current && webcamRef?.current?.stream;
      if (myStream && activePermission) {
        const mediaRecord = new MediaRecorder(myStream, {
          audioBitsPerSecond: 128000,
          videoBitsPerSecond: 2000000,
        });
        mediaRecorderRef.current = mediaRecord;
      }

      mediaRecorderRef?.current?.addEventListener(
        'dataavailable',

        handleDataAvailable,
      );

      mediaRecorderRef.current.start();
      setStep();
    } catch (error) {
      throw new Error('error when recording');
    }
  };

  React.useEffect(() => {
    if (sec === MIN_TIME_SEC_RECORD) {
      setDisableButtonRecord(false);
    }
  }, [sec, disableButtonRecord]);
  const handleStopRecordVideo = () => {
    setVideoDurationTotal({
      id: step - 1,
      duration: videoDuration,
    });
    try {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      setSect(0);
      setPlayVideo(true);
    } catch (error) {
      throw new Error('error when stop recording');
    }
  };

  const handleRemoveVideo = () => {
    deleteVideoById(step - 1);
    setRecordChunks([]);
    setPlayVideo(false);
    setDisableButtonRecord(true);
    decrementStep();
  };

  const handleProgressPlayVideo = (state: any) => {
    setPlayedSeconds(state.playedSeconds);
  };
  const handleNavigate = async () => {
    if (step <= 4) {
      if (step === 1 && currentLevel.id === 1) {
        setStep();
      }
      if (step === 2 && currentLevel.id === 1) {
        setIsloading(true);
        const recordedBlob = recordChunkToBlob(recordChunks);

        const res: any = await uploadVideStep(recordedBlob, candidateId);

        if (res?.message === 'success') {
          const blobUrlLevel = generateBlobUrl(recordChunks);
          updateLevel(currentLevel.id, blobUrlLevel);

          updateActiveStatus(1, false);
          updatePassedStatus(1, true);
          updateActiveStatus(2, true);
          setIsRecording(false);
          setPlayVideo(false);
          setIsloading(false);

          setRecordChunks([]);
        }
      }
      if (step === 3 && currentLevel.id === 2) {
        setIsloading(true);

        const blobUrlLevel = generateBlobUrl(recordChunks);
        const recordedBlob = recordChunkToBlob(recordChunks);

        const res = await uploadVideStep(recordedBlob, candidateId);
        if (res?.message === 'success') {
          updateLevel(currentLevel.id, blobUrlLevel);

          updateActiveStatus(2, false);
          updatePassedStatus(2, true);
          updateActiveStatus(3, true);
          updateActiveStatus(1, false);
          setIsloading(false);

          setIsRecording(false);
          setPlayVideo(false);

          setRecordChunks([]);
        }
      }

      if (step === 4 && currentLevel.id === 3) {
        setIsloading(true);

        const blobUrlLevel = generateBlobUrl(recordChunks);
        const recordedBlob = recordChunkToBlob(recordChunks);
        const res = await uploadVideStep(recordedBlob, candidateId);

        if (res?.message === 'success') {
          updatePassedStatus(3, true);
          updateActiveStatus(3, false);
          updateLevel(currentLevel.id, blobUrlLevel);
          setPlayVideo(false);
          return navigation(Paths.ChoosePhotosPage);
        }
      }
    }
  };

  const handleAcceptContract = () => {
    if (!isAcceptedContract) {
      setIsAcceptedContract(true);
      setOpenDialogContract(false);
      setIsShowHint(true);
    } else {
      setIsAcceptedContract(false);
      setOpenDialogContract(false);
    }
  };

  React.useEffect(() => {
    if (sec === maxTimeRecord) {
      handleStopRecordVideo();
      const blobUrlLevel = generateBlobUrl(recordChunks);
      updateLevel(currentLevel.id, blobUrlLevel);
    }
  }, [sec]);

  const handleUserMediaError = (error: unknown) => {
    if (error) {
      setErrorMessage(`Une erreur s'est produite lors de l'enregistrement`);
    }
  };

  return (
    <Stack
      sx={{
        position: 'relative',
      }}
    >
      {!isAcceptedContract && !isShowHintDialaog && (
        <DialogContract
          open={openDialogContract}
          handleClickClose={handleCloseDialogContract}
          handleAcceptContract={handleAcceptContract}
        />
      )}
      {isShowHintDialaog && (
        <DialogHint
          open={isShowHintDialaog}
          handleClickClose={handleCloseDialogContract}
        />
      )}

      {activePermission && !playVideo && (
        <Box sx={{ position: 'relative' }}>
          {errorMessage && errorMessage.length > 0 ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography variant="h2"> {errorMessage}</Typography>
            </Box>
          ) : (
            <Webcam
              onUserMediaError={handleUserMediaError}
              ref={webcamRef}
              style={{
                height: '95dvh',
                width: '100%',
                objectFit: 'cover',
              }}
              muted
              audio
              videoConstraints={videoConstraints}
              audioConstraints={audioConstraints}
            />
          )}
          <Grid
            container
            sx={{
              position: 'absolute',
              zIndex: '10',
              top: '40px',
              width: '100%',
            }}
          >
            <Grid
              item
              md={12}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
              }}
            >
              {isRecording && (
                <>
                  <Box>
                    {currentLevel.id === 1 && (
                      <StepLabel stepLabel={allsteps[0]} />
                    )}
                    {currentLevel.id === 2 && (
                      <StepLabel stepLabel={allsteps[1]} />
                    )}
                    {currentLevel.id === 3 && (
                      <StepLabel stepLabel={allsteps[2]} />
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'row',
                      marginBottom: '8px',
                    }}
                  >
                    <Box>
                      <ProgressTimer
                        value={sec}
                        maxTimeSecRecord={maxTimeRecord}
                      />
                    </Box>
                  </Box>
                </>
              )}
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {!isRecording && (
                    <StepLabel
                      allsteps={allsteps}
                      step={step}
                      id={currentLevel.id}
                      isActive={currentLevel.isActive}
                      isPassed={currentLevel.isPassed}
                      levels={levels}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
          {isRecording ? (
            <Grid
              container
              sx={{
                position: 'absolute',
                bottom: '56px',
                zIndex: '10',
                justifyContent: 'center',
              }}
            >
              <Grid item>
                <IconButton onClick={handleStopRecordVideo}>
                  <VideoStopRecordIcon width="100px" height="100px" />
                </IconButton>
              </Grid>
            </Grid>
          ) : (
            <Grid
              container
              sx={{
                position: 'absolute',
                bottom: '56px',
                zIndex: '10',
                justifyContent: 'center',
              }}
            >
              <Grid item>
                <IconButton onClick={handleStartRecordVideo}>
                  <VidoRecordIcon width="100px" height="100px" />
                </IconButton>
              </Grid>
            </Grid>
          )}
        </Box>
      )}

      {playVideo && (
        <Box>
          <Box>
            <Grid
              container
              sx={{
                position: 'absolute',
                top: '40px',
                marginInline: 'auto',
                zIndex: '10',
                justifyContent: 'center',
              }}
            >
              <Grid item>
                <VideoProgressPlayer
                  videoDuration={currentLevel.timeRecord}
                  onClick={handleVideoClick}
                  play={isVideoPlaying}
                  playedSeconds={Math.round(playedSeconds)}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                height: '95vh',
                objectFit: 'cover',
              }}
            >
              <Video
                playing={isVideoPlaying}
                url={currentLevel.videoRecord}
                ref={videoRef}
                width="100%"
                loop
                height="100%"
                sx={{
                  objectFit: 'cover !important',
                  '& video': {
                    objectFit: 'cover',
                  },
                }}
                onProgress={(state) => handleProgressPlayVideo(state)}
              />
            </Box>
          </Box>

          <Box sx={{ position: 'absolute', bottom: '56px', left: '40%' }}>
            <Button
              onClick={handleRemoveVideo}
              sx={{
                width: '164px',
                height: '72px',
                background: '#FFF7FC24',
                marginRight: '24px',
                border: 'solid 1px white',
                borderRadius: '56px',
                color: '#fff',
                textTransform: 'capitalize',
                justifyContent: 'center',
              }}
            >
              <KeyboardBackspaceIcon
                fontSize="large"
                htmlColor="#ffff"
                sx={{ marginRight: '8px', marginLeft: '16px' }}
              />
              <Typography variant="h6" sx={{ marginRight: '24px' }}>
                Refaire
              </Typography>
            </Button>

            <Button
              disabled={loading}
              onClick={step === 1 ? setStep : handleNavigate}
              sx={{
                background: loading ? 'grey' : '#3AA05C',
                height: '72px',
                borderRadius: '56px',
                boxShadow: '0px 3px 12px 0px rgba(0, 0, 0, 0.48)',
                '&:hover': {
                  transform: 'scale(1.05)',
                  background: loading ? 'grey' : '#3AA05C',
                },
              }}
            >
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{ mr: 1, color: 'white !important' }}
                />
              )}
              <Typography
                sx={{
                  color: '#FEFEFE',
                  fontFamily: 'Inter',
                  fontSize: '24px',
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: '36px',
                  textTransform: 'initial',
                  marginLeft: '12px',
                }}
              >
                Enregistrer et continuer
              </Typography>
              {!loading && (
                <IconButton>
                  <EastIcon fontSize="large" htmlColor="#ffff" />
                </IconButton>
              )}
            </Button>
          </Box>
        </Box>
      )}

      {errorPermission && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Alert severity="warning" color="warning">
            {errorPermission}
          </Alert>
        </Box>
      )}
    </Stack>
  );
}

export default CvVideoCard;
